
export const oauth2 = {
    resource:"https://fridaygroup.dk/5db0b618-a3cc-4add-9ec1-e76930c2b701",
    grant_type:"password",
    client_id:"1f02347e-ff51-467f-bd92-b038677073ec",
    url:"https://cors-anywhere.herokuapp.com/https://login.microsoftonline.com/e1c77e9f-2bb2-4a1a-8461-8e2bd6c201ca/oauth2/token"
    //url:"https://login.microsoftonline.com/e1c77e9f-2bb2-4a1a-8461-8e2bd6c201ca/oauth2/token"
}

